;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:linkedregistrations-ui":true});}catch(e){}}();import getEnvValue from './getEnvValue';

export type FeatureFlags = {
  WEB_STORE_INTEGRATION: boolean;
};

const getFeatureFlags = (): FeatureFlags => ({
  WEB_STORE_INTEGRATION:
    getEnvValue('NEXT_PUBLIC_WEB_STORE_INTEGRATION_ENABLED') === 'true',
});

const isFeatureEnabled = (feature: keyof FeatureFlags): boolean =>
  getFeatureFlags()[feature];

export const featureFlagUtils = {
  isFeatureEnabled,
  getFeatureFlags,
};
